import toast from "react-hot-toast";
import { safeGet, safePost, safeDelete } from "../../../config/axiosClient.js";

export const getAnnouncementData = () => {
    return async dispatch => {
        console.log('Fetching announcement data');
        const { data, error } = await safeGet('/api/special');

        if (error) {
            // Logged by axiosClient, app will retry on next poll
            return;
        }

        if (data?.success) {
            let data_array = [...data.data];
            let new_array = [];
            for (var i = 0; i < data_array.length; i++) {
                let status = "";
                if (new Date((data_array[i]).Expire) > new Date(Date.now())) {
                    status = "Actived";
                }
                else {
                    status = "Expired";
                }
                let json_data = {
                    ...data_array[i],
                    Stauts: status
                }
                new_array.push(json_data);
            }
            dispatch({
                type: "Set_Announcement_Data",
                data: new_array
            });
        }
    };
}

export const setAnnouncementData = (returnArray) => {
    return dispatch => {
        let data_array = [...returnArray];
        let new_array = [];
        for (var i = 0; i < data_array.length; i++) {
            let status = "";
            if (new Date((data_array[i]).Expire) > new Date(Date.now())) {
                status = "Actived";
            }
            else {
                status = "Expired";
            }
            let json_data = {
                ...data_array[i],
                Stauts: status
            }
            new_array.push(json_data);
        }
        dispatch({
            type: "Set_Announcement_Data",
            data: new_array
        });
    };
}

export const deleteAnnouncementData = (id) => {
    return async dispatch => {
        const { data, error } = await safeDelete(`/api/special/${id}`);

        if (error) {
            console.error('Error deleting announcement:', error.message);
            if (!error.isOffline) {
                toast.error('Failed to delete announcement');
            }
            return;
        }

        if (data?.success) {
            dispatch({
                type: "Set_Announcement_Data",
                data: data.data
            });
        }
    };
}

export const addAnnouncementData = (Topic, Expire, Post, Type, newArray, numberType) => {
    return async dispatch => {
        let now_time = new Date();

        if (numberType === "day") {
            now_time.setDate(now_time.getDate() + Expire);
        }
        else if (numberType === "hour") {
            now_time.setHours(now_time.getHours() + Expire);
        }
        else {
            now_time.setMinutes(now_time.getMinutes() + Expire);
        }

        const { data, error } = await safePost("/api/special", {
            topic: Topic,
            status: "Active",
            expire: now_time,
            post: Post,
            type: Type,
            airportInfo: newArray
        });

        if (error) {
            console.error('Error adding announcement:', error.message);
            if (!error.isOffline) {
                toast.error("Failed to add announcement - check your input data");
            }
            return;
        }

        if (data?.success) {
            dispatch({
                type: "Set_Announcement_Data",
                data: data.data
            });
        }
    };
}
